import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { trackByProp } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import { AdminsAvatarsComponent, AvatarComponent, RtTooltip } from '@recruitee/user-interface';

import { FollowersCounterComponent } from '../followers-counter/followers-counter.component';

@Component({
  selector: 'rt-total-followers',
  templateUrl: './total-followers.component.html',
  styleUrls: ['./total-followers.component.less'],
  imports: [
    CommonModule,
    AvatarComponent,
    AdminsAvatarsComponent,
    RtTooltip,
    FollowersCounterComponent,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalFollowersComponent {
  private static VISIBLE_USERS_THRESHOLD = 15;

  @Input()
  public set users(users: User[]) {
    if (!users?.length) {
      return;
    }

    this._users = users;
    this.visibleUsers = this.cutUsers(users);
    this.otherFollowersCount = users.length - this.visibleUsers.length;
    this.cdRef.detectChanges();
  }

  public readonly trackById = trackByProp<{ id: number }>({ prop: 'id' });
  public _users: User[] = [];
  public visibleUsers: User[] = [];
  public otherFollowersCount = 0;

  constructor(private cdRef: ChangeDetectorRef) {}

  private cutUsers(users: User[]): User[] {
    return users.slice(0, TotalFollowersComponent.VISIBLE_USERS_THRESHOLD);
  }
}
